export interface Testimonial {
  /** Bleibt leer — wird später eingesetzt. */
  quote: string
  /** Bleibt leer — wird später eingesetzt. */
  name: string
  /** Bleibt leer — wird später eingesetzt. */
  role: string
}

/** Sechs leere Bewertungskarten. Texte, Namen und Schulformen folgen später. */
export const testimonials: Testimonial[] = [
  { quote: '', name: '', role: '' },
  { quote: '', name: '', role: '' },
  { quote: '', name: '', role: '' },
  { quote: '', name: '', role: '' },
  { quote: '', name: '', role: '' },
  { quote: '', name: '', role: '' },
]
